import React, { useMemo } from "react";
import { motion } from "framer-motion/dist/framer-motion";

const COLORS = ["#ff6b9d", "#ffa07a", "#ffd93d", "#c44569", "#ff1493", "#ffb3d1"];

const Petals = ({ count = 28 }) => {
  const petals = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 10,
        duration: 14 + Math.random() * 12,
        size: 10 + Math.random() * 18,
        color: COLORS[i % COLORS.length],
        rotate: Math.random() * 360,
        sway: 20 + Math.random() * 40,
      })),
    [count]
  );

  return (
    <div className="md-petals-layer" aria-hidden>
      {petals.map((p) => (
        <motion.span
          key={p.id}
          className="md-petal"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 1.2,
            background: p.color,
            transform: `rotate(${p.rotate}deg)`,
          }}
          initial={{ y: -60, opacity: 0 }}
          animate={{
            y: ["-5%", "108vh"],
            x: [0, p.sway, -p.sway, p.sway * 0.6, 0],
            opacity: [0, 0.65, 0.65, 0.45, 0],
            rotate: [p.rotate, p.rotate + 240],
          }}
          transition={{ duration: p.duration, delay: p.delay, repeat: Infinity, ease: "linear" }}
        />
      ))}
    </div>
  );
};

export default Petals;
